import React from 'react';
import PropTypes from 'prop-types';

import { VisuallyHidden } from '../../styled/accessibility';
import { Label } from '../../styled/label';

const FieldLabel = ({
  label,
  labelHiddenText,
  name,
  required,
  hideOptionalMessage,
  labelSize,
  as,
}) => {
  const optionalPostfix = !required && !hideOptionalMessage && ' (optional)';
  const forLabel = as === 'legend' ? false : name;

  if (label) {
    return (
      <Label htmlFor={forLabel} $labelSize={labelSize} as={as}>
        {label}
        {labelHiddenText ? (
          <VisuallyHidden>{labelHiddenText}</VisuallyHidden>
        ) : null}
        {optionalPostfix}
      </Label>
    );
  }

  if (labelHiddenText) {
    return (
      <VisuallyHidden as="label" htmlFor={name}>
        {labelHiddenText}
        {optionalPostfix}
      </VisuallyHidden>
    );
  }
  return null;
};

FieldLabel.defaultProps = {
  as: 'label',
};

FieldLabel.propTypes = {
  label: PropTypes.string,
  labelHiddenText: PropTypes.string,
  labelSize: PropTypes.string,
  name: PropTypes.string,
  required: PropTypes.bool,
  hideOptionalMessage: PropTypes.bool,
  as: PropTypes.elementType,
};

FieldLabel.defaultProps = {
  labelSize: 'standard',
};

export default FieldLabel;
